import * as React from 'react';
import ReactSVG from 'react-svg'
import styled from 'styled-components';
import { translate } from "react-i18next";
import IconPrevious from './../../../icons/prev.svg';
import IconNext from './../../../icons/next.svg';

const StyledSidebar = styled.div`
    display: block;
    width: ${props => props.visible ? props.defaultWidth : '45px'};
    flex-shrink: 0;
    transition: width 0.5s;
    resize: horizontal;
    position: relative;
    height: 100%;
    background-color: #f8f8f8;
    color: #1f1f1f;
`

const ChildrenWrapper = styled.div`
    visibility: ${props => props.visible ? 'visible' : 'hidden'};
    height: calc(100% - 50px);
`

const Overlay = styled.div`
    position: absolute;
    height: calc(100% - 5px);
    width: 100%;
    left: ${props => props.location === 'left'
        ? props.visible
            ? '-100%'
            : '0'
        : 'unset'
    };
    right: ${props => props.visible && props.location === 'right' ? '-100%' : '0'};
    background-color: #fcfcfc;
    z-index: 20;
    transition: ${props => props.visible ? 'all 0.4s' : 'all 0.4s'};
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
        >p{
            transform: rotate(-90deg) translate(-50%, 0);
            white-space: nowrap;
            color: #265a9c;
            font-weight: bold;
            flex-shrink: 0;
        }
    }
`;

const Break = styled.hr`
    margin: 0;
    z-index: 21;
    position: absolute;
    width: calc(100% - 3px);
    border: 0.5px solid #b7b7b7;
`;

const ToggleButton = styled.div`
    pointer-events: ${props => props.disabled ? 'none' : 'all'};
    padding: 0 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 21;
    bottom: 10px;
    right: ${props => props.location === 'right' ? '2px' : 'unset'};
    left: ${props => props.location === 'left' ? '2px' : 'unset'};
    width: ${props => props.visible ? '75px' : '25px'};
    height: 25px;
    background-color: rgba(0, 0, 0, 0);
    border: 2px solid #265a9c;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    transition: width 0.5s;
    cursor: pointer;
    :hover{
        background-color: #f3f3f3;    
        box-shadow: 0 2px 4px rgba(0,0,0,0.16), 0 2px 4px rgba(0,0,0,0.23);
    }
    >div>div{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    >p{
        margin: 0;
        color: #265a9c;
    }
`;

type Props = any;
type State = any;

class Sidebar extends React.Component<Props, State> {
    toggleContentVisibility = () => {
        if (this.state.contentVisible)
            setTimeout(() => {
                this.setState({ contentVisible: false });
            }, 500)
        if (!this.state.contentVisible)
            this.setState({ contentVisible: true });
    }

    animateMapResize = () => {
        this.setState({ toggleDisabled: true })
        const callbackInterval = setInterval(() => {
            this.props.resizeObservable.fireCallbacks();
        }, 30)
        setTimeout(() => {
            clearInterval(callbackInterval);
            this.setState({ toggleDisabled: false })
        }, 500)
    }

    constructor() {
        super();
        this.state = {
            visible: true,
            contentVisible: true,
            toggleDisabled: false,
        }
    }
    render() {
        const { visible, contentVisible } = this.state;
        const { location, children, defaultWidth, title, t } = this.props;
        return (
            <StyledSidebar
                className='sidebar'
                visible={visible}
                location={location}
                defaultWidth={defaultWidth}
            >
                <Overlay visible={visible} location={location} >
                    <p>{title}</p>
                </Overlay>
                <ChildrenWrapper
                    visible={contentVisible}
                >
                    {children}
                </ChildrenWrapper>
                <Break />
                <ToggleButton
                    location={location}
                    visible={visible}
                    disabled={this.state.toggleDisabled}
                    onClick={() => {
                        this.setState({ visible: !visible })
                        this.animateMapResize();
                        this.toggleContentVisibility();
                    }}
                >
                    {visible && location === 'left'
                        ? <p>{String(t('Hide'))}</p>
                        : ''
                    }
                    <ReactSVG
                        path={location === 'left'
                            ? visible ? IconPrevious : IconNext
                            : visible ? IconNext : IconPrevious
                        }
                        style={{
                            fill: '#265a9c',
                            width: '17px',
                            height: '17px',
                        }}
                    />
                    {visible && location === 'right'
                        ? <p>{String(t('Hide'))}</p>
                        : ''
                    }
                </ToggleButton>
            </StyledSidebar>
        )
    }
}

export default translate("translations")(Sidebar);


// WEBPACK FOOTER //
// ./src/containers/content/sidebar/Sidebar.jsx